"use client"

import { Anchor } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AnchorIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AnchorIcon = component(Icon)({ as: Anchor })
